import $ from 'jquery';
export default [
	function () {
		var ERROR_CLASS = '.ng-invalid:visible';

		return {
			restrict: 'A',
			link: function ($scope, $elem) {
				$elem = $($elem);
				var $form = $elem.closest('form');

				function animateTo(elem) {
					var viewPortHeight = window.innerHeight || 0;

					$('html, body').animate(
						{
							scrollTop: Math.ceil(elem.offset().top - viewPortHeight / 2)
						},
						1000
					);
				}

				function animateToFirstError() {
					var $firstError = $form.find(ERROR_CLASS).first();

					if ($firstError.length) {
						var elementOffset = $firstError.offset().top;
						var elementHeight = $firstError.height();
						if (elementHeight < elementOffset) {
							animateTo($firstError);
						}
					}
				}

				function handleClick() {
					setTimeout(animateToFirstError, 100);
				}

				$elem.click(handleClick);
			}
		};
	}
];
